<template>
<div>
  <range-filter
    v-if="config"
    ref="range"
    class="global-date-filter"
    :data="config"
    @change="handleChange" />
</div>
</template>

<script>
import RangeFilter from 'macarons-graphs-front/src/filter/RangeFilter.vue'

export default {
  components: {
    RangeFilter
  },
  props: {
    value: null
  },
  data () {
    return {
      config: null
    }
  },
  mounted () {
    Promise.all([
      this.$store.dispatch('customGraph/loadDimensions'),
      this.$store.dispatch('customGraph/loadDimension', '[Date].[Année]'),
      this.$store.dispatch('customGraph/loadValues', '[Date].[Année]')
    ]).then(() => {
      this.config = {
        defaultValues: [],
        options: {
          type: 'range'
        },
        value: this.$store.getters['customGraph/dimension']('[Date].[Année]')
      }
    })
  },
  methods: {
    handleChange (data) {
      this.$emit('input', {
        range: this.$refs.range.value,
        values: data.values.map(v => v.uniqueName)
      })
      this.$emit('change')
    },
    setRange (range) {
      if (!this.config || !this.$refs.range) {
        return new Promise(resolve => {
          setTimeout(() => resolve(this.setRange(range)), 200)
        })
      } else {
        return this.$refs.range.load().then(() => {
          this.$refs.range.value = range
          this.$refs.range.handleChange(range)
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/macarons/components/YearRangeSelect.vue